import React from 'react';

import { type EmojiCategory, type EmojiCollectionData, useEmojiCollection } from '@pkg/hooks';

import { EmojiAction, EmptyState } from './components';
import { collectItems, filterItems } from './utilities';

import { Item, List, StyledEmojiList } from './styles';

export interface EmojiListProps {
    category?: EmojiCategory;
    keywordFilter?: string;
    darkMode?: boolean;
    onSelectEmoji(emoji: EmojiCollectionData['glyph']): void;
}

// TODO: Consider storing a collection of "selected emojis".
export function EmojiList({ category, keywordFilter, darkMode = false, onSelectEmoji }: EmojiListProps) {
    const { collection } = useEmojiCollection();

    const items = collectItems(collection, category);
    const filteredItems = filterItems(items, keywordFilter);

    const itemsMarkup = filteredItems.map(({ glyph }) => (
        <Item key={`EmojiList-Item-${glyph}`}>
            <EmojiAction glyph={glyph} onAction={() => onSelectEmoji(glyph)} />
        </Item>
    ));

    const mainContentMarkup = itemsMarkup.length ? <List>{itemsMarkup}</List> : <EmptyState />;

    return <StyledEmojiList $darkMode={darkMode}>{mainContentMarkup}</StyledEmojiList>;
}
